import { render, staticRenderFns } from "./ValidationLayout.vue?vue&type=template&id=f6206606&scoped=true&lang=pug"
import script from "./ValidationLayout.vue?vue&type=script&lang=js"
export * from "./ValidationLayout.vue?vue&type=script&lang=js"
import style0 from "./ValidationLayout.vue?vue&type=style&index=0&id=f6206606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6206606",
  null
  
)

export default component.exports